// extracted by mini-css-extract-plugin
export default {"blueBorderColor":"#9CCDFD","blackText":"#111","imageContainer":"CategoryLink_imageContainer__bzv-Z","link":"CategoryLink_link__SRUMQ"};